export const DEFAULT_NEW_EVENT_DURATION = 30;

/**
 * @deprecated use the values from the Redux store instead
 */
export const NEW_EVENT_DURATIONS = [15, 30, 45, 60, 90, 120, 180, 240, 300, 360, 420, 480];
